/**
 * Sentinelle « cellule vide » : pas de perle posée à cette position.
 *
 * Utilisée dans `Pattern.cells` partout où un index de palette serait attendu.
 * `-1` est choisi parce que :
 *  - il survit tel quel à JSON.stringify (round-trip persistence sans perte)
 *  - il sort naturellement de la plage valide `[0, palette.length)`, donc
 *    `palette[EMPTY] === undefined` → les renderers existants l'ignorent déjà
 *  - lisible à la lecture (vs. `null` qui demande un type union)
 *
 * Sémantique :
 *  - rendu : aucune perle dessinée, on voit le fond de la plaque (canvasBg)
 *  - counts : la cellule n'est PAS comptée (pas de perle à acheter)
 *  - flood fill : les EMPTY forment leur propre groupe connexe (on remplit
 *    une zone vide comme on remplirait une zone d'une couleur précise)
 *  - undo/redo : `-1` est une valeur d'index comme une autre dans CellEdit
 */
export const EMPTY = -1;

/** Vrai si la cellule est vide (pas de perle posée). */
export function isEmpty(idx: number): boolean {
  return idx < 0;
}
